enum Dv360ReportType {
  DATE = 'DATE',
  CHANNEL = 'CHANNEL',
  DEVICE = 'DEVICE',
  CAMPAIGN = 'CAMPAIGN',
  ADVERTISER = 'ADVERTISER',
  PLACEMENT = 'PLACEMENT',
  CREATIVE = 'CREATIVE',
  PUBLISHER = 'PUBLISHER',
  DAYS_OF_WEEK = 'DAYS_OF_WEEK',
  DAYPART = 'DAYPART',
  DMA = 'DMA',
  STATE = 'STATE',
  TOTAL = 'TOTAL',
  APP_URL = 'APP_URL',
}

export default Dv360ReportType;
